import {config} from '../config'

export const isIos = (): boolean => Boolean(config.isIos)
